import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step941468Meta extends BaseModel {
  /**
   * @var {bool}
   */
  hasAcknowledgedMeetingPreparation;

  constructor(model = {}) {
    super();
    this.hasAcknowledgedMeetingPreparation = model.hasAcknowledgedMeetingPreparation ?? false;
  }
}
